import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CanDeactivateGuard } from './services/can-deactivate-guard.service';
import { StoryDetailResolver } from './services/story-resolver.service';
import { NewsroomComponent } from './components/Newsroom/newsroom.component';
import { StoryComponent } from './components/story/story.component';

const newsroomRoutes: Routes = [
    {
        path: 'Newsroom',
        component: NewsroomComponent,
        children: [
            {
                path: 'story/:id',
                component: StoryComponent,
                canDeactivate: [CanDeactivateGuard],
                resolve: {
                    routeModel: StoryDetailResolver
                },
                runGuardsAndResolvers: 'always'
            },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(newsroomRoutes)
    ],
    exports: [
        RouterModule
    ],
    providers: [
        StoryDetailResolver
    ]
})
export class NewsroomRoutingModule { }
